import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Users from '../../../components/users/Users';
import NothingFound from '../../../components/NothingFound';
import NothingToAdd from '../../../components/NothingToAdd';
import AddMemberSearch from '../../../components/addMember/AddMemberSearch';

import * as bucketConstants from '../../../constants/buckets';
import * as organizationMembersSelectors from '../../../selectors/organizationMembersSelectors';
import * as bucketSelectors from '../../../selectors/bucketSelectors';
import * as bucketMembersSelectors from '../../../selectors/bucketMembersSelectors';

import { getFilterMembersCallback } from '../../../helpers/Util';

const ACTIONS = ['Add as member', 'Add as admin'];

class AddBucketMembersContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { query: '' };
    }

    onSearchChange = query => {
        this.setState({ query });
    };

    onAddMembers = (usersIds, action) => {
        const { addMembers, bucket } = this.props;
        const usersToBeAdded = usersIds.map(userId => ({
            memberId: userId,
            isAdmin: ACTIONS.indexOf(action) === 1,
        }));
        addMembers({ usersToBeAdded, bucketId: bucket.id });
    };

    render() {
        const { organizationMembers, members, hideAddMembers } = this.props;
        const { query } = this.state;
        const filterCallback = getFilterMembersCallback(query);
        // filter organization members that are not already added to the bucket
        // Note: Elements from members (bucket members) can be removed/added
        // outside of the component and passed as props, that's why we filter it in
        // the render method
        let users = organizationMembers.filter(
            member =>
                members.findIndex(
                    bucketMember => bucketMember.id === member.id,
                ) === -1,
        );

        // if there is no users to add, don't show the search field
        // and don't filter the users
        const withSearch = !!users.length;
        let result;
        if (users.length) {
            users = users.filter(filterCallback);
            result = (
                <React.Fragment>
                    <Users
                        users={users || []}
                        actions={ACTIONS}
                        onAction={this.onAddMembers}
                        showIndividualActions={false}
                    />
                    {!users.length && <NothingFound />}
                </React.Fragment>
            );
        } else {
            result = <NothingToAdd />;
        }

        users = users.filter(filterCallback);

        return (
            <React.Fragment>
                <AddMemberSearch
                    withSearch={withSearch}
                    onBack={hideAddMembers}
                    onChange={this.onSearchChange}
                    searchPlaceholder="Type a name..."
                />
                {result}
            </React.Fragment>
        );
    }
}

AddBucketMembersContent.propTypes = {
    organizationMembers: PropTypes.array,
    bucket: PropTypes.object.isRequired,
    members: PropTypes.array.isRequired,
};

AddBucketMembersContent.defaultProps = {
    organizationMembers: [],
};

const mapStateToProps = state => ({
    organizationMembers: organizationMembersSelectors.getMembers(state),
    bucket: bucketSelectors.getBucket(state),
    members: bucketMembersSelectors.getMembers(state),
});

const mapDispatchToProps = dispatch => ({
    addMembers: payload =>
        dispatch({
            type: bucketConstants.ADD_BUCKET_MEMBERS_REQUEST,
            payload,
        }),
    hideAddMembers: () =>
        dispatch({
            type: bucketConstants.TOGGLE_ADD_MEMBER,
            payload: { isAddMember: false },
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddBucketMembersContent);



// WEBPACK FOOTER //
// ./src/containers/bucketMembers/addBucketMembers/AddBucketMembersContent.js